// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1ZyD7","emails":"CreateEditClinics_emails__1Yu2v","emailTagLabel":"CreateEditClinics_emailTagLabel__1QWEw"};